import { custom_temp_upload_placeholder_png } from "@/assets/images";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";

import { useCommonStore, useUserStore } from "@/stores";
import { TYPE_LIMIT_ACCEPT } from "@/constants";
import { ArrowUpSvg, CustomUploadSvg } from "@/assets/icons";
import clsx from "clsx";
import { isEmpty } from "lodash-es";
import { useCustomTemp } from "@/hooks";
import { useEffect, useRef, useState } from "react";
import loadable from "@loadable/component";
const FotorPictureSelect = loadable(() => import("@ft/picture-select"));
const CustomTempUpload = () => {
  const { t } = useTranslation();
  
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const { handleCustomTemp } = useCustomTemp();

  const isLogin = useUserStore(state => state.getters.isLogin);
  const showLogin = useUserStore(state => state.showLogin);
  const chooseTemp = useCommonStore(state => state.chooseTemp);

  const handleSelect = (files: any) => {    
    if (!isEmpty(files)) {
      const { file, url } = files[0];
      chooseTemp(file || url);
    }
  }

  const handleOpenChange = (value: boolean) => {
    setOpen(value);
  }

  useEffect(() => {
    const listner = (e: MouseEvent) => {
      const target = e.target as Element;
      if (triggerRef.current && !triggerRef.current.contains(target)) {
        setOpen(false);
      }
    }

    document.addEventListener("click", listner);

    return () => {
      document.removeEventListener("click", listner);
    }
  }, []);

  return (
    <div
      className={clsx(
        styles["root"],
      )}
    >
      <div
        className={styles["inner"]}
      >
        <img
          className={styles["placeholder"]}
          src={custom_temp_upload_placeholder_png}
          alt=""
        />

        <div
          className={styles["title"]}
        >
          {t("custom_temp_upload_title")}
        </div>

        <div
          className={styles["upload_button_wrap"]}
        >
          <button
            className={styles["custom_temp_upload_button"]}
            onClick={handleCustomTemp}
          >
            <CustomUploadSvg
              className={styles["upload_svg"]}
            ></CustomUploadSvg>
            <span
              className={styles["text"]}
            >
              {t("custom_temp_upload_button")}
            </span>
          </button> 

          <span
            className={styles["split"]}
          ></span>

          <FotorPictureSelect
            isLogin={isLogin}
            domain={process.env.REACT_APP_BASE_URL}
            fotorCloudDomain={process.env.REACT_APP_FOTOR_CLOUD_URL}
            theme="light"
            isDropboxChooser={false}
            accept={TYPE_LIMIT_ACCEPT}
            limitCount={1}
            hiddenFromItems={["from_google_photo", "from_dropbox", "from_dropbox_chooser"]}
            onSelect={handleSelect}
            onLogin={showLogin}
            placement="bottom-right"
            onOpenChange={handleOpenChange}
          >
            <button
              ref={triggerRef}
              className={clsx(
                styles["picture_select_trigger"],
                open && styles["open"]
              )}
            >
              <ArrowUpSvg
                className={styles["arrow_svg"]}
              ></ArrowUpSvg>
            </button>
          </FotorPictureSelect>
        </div>
      </div>
    </div>
  )
}

export default CustomTempUpload;